import { Component, OnInit, Input } from '@angular/core';
import { BottomsheetShared } from '../shared/bottomsheet-shared';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { LoadingShared } from '../shared/loading-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { BlogShared } from '../shared/blog-shared';

@Component({
  selector: 'app-report-bottomsheet',
  templateUrl: './report-bottomsheet.component.html',
  styleUrls: ['./report-bottomsheet.component.scss'],
})
export class ReportBottomsheetComponent implements OnInit {
  @Input() data: ReportBottomsheetModel;

  height = 0;

  constructor(
    private bottomsheetShared: BottomsheetShared,
    private blogService: BlogService,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService,
    private blogShared: BlogShared
  ) {}

  ngOnInit() {
    if (this.data.secondTitle !== '') {
      this.height = 110 + this.data.optionsTitle.length * 40;
    } else {
      this.height = 66 + this.data.optionsTitle.length * 40;
    }
    setTimeout(() => {
      this.animateUp();
    }, 100);
  }

  closeBottomsheet() {
    document.getElementById('reportBottomsheet').style.top = '100%';
    document.getElementById('bottomsheet-dark-view').style.height = '100%';
    setTimeout(() => {
      this.bottomsheetShared.closeReportBottomsheet();
    }, 300);
  }

  animateUp() {
    document.getElementById('reportBottomsheet').style.top =
      'calc( 100% - ' + this.height.toString() + 'px )';
    document.getElementById('bottomsheet-dark-view').style.height =
      'calc( 100% - ' + (this.height - 30).toString() + 'px )';
  }

  onClick(id: number) {
    if (this.data.type === 'post') {
      this.loadingShared.showLoading();
      this.blogService
        .reportBlogPost(this.data.postId, this.data.optionsTitle[id])
        .then((res) => {
          if (res.isSuccess()) {
            document.getElementById('bottomsheet-first').style.right = '-100%';
            document.getElementById('bottomsheet-second').style.right = '0';
            // this.analyticTribunePostReported(this.data.optionsTitle[id]);
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    } else if (this.data.type === 'comment') {
      this.loadingShared.showLoading();
      this.blogService
        .reportBlogComment(this.data.id, this.data.optionsTitle[id])
        .then((res) => {
          if (res.isSuccess()) {
            document.getElementById('bottomsheet-first').style.right = '-100%';
            document.getElementById('bottomsheet-second').style.right = '0';
            // this.analyticTribuneCommentReported(this.data.optionsTitle[id]);
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    } else if (this.data.type === 'reply') {
      this.loadingShared.showLoading();
      this.blogService
        .reportBlogReply(this.data.id, this.data.optionsTitle[id])
        .then((res) => {
          if (res.isSuccess()) {
            document.getElementById('bottomsheet-first').style.right = '-100%';
            document.getElementById('bottomsheet-second').style.right = '0';
            // this.analyticTribuneReplyReported(this.data.optionsTitle[id]);
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    } else if (this.data.type === 'image') {
      if (id === 0) {
        this.closeBottomsheet();
        setTimeout(() => {
          this.blogShared.openBlogImageCropper();
        }, 300);
      } else if (id === 1) {
        this.blogShared.deleteBlogImage();
      }
    }
  }

  // analyticTribunePostReported(reason: string) {
  //   let json: JSON;
  //   let obj: any = {
  //     'reason' : reason
  //   };
  //   json = <JSON> obj;
  //   gtag('event', 'tribune_post_reported', {
  //     'event_category': 'Tribune',
  //     'event_label': JSON.stringify(json)
  //   });
  // }

  // analyticTribuneCommentReported(reason: string) {
  //   let json: JSON;
  //   let obj: any = {
  //     'reason' : reason
  //   };
  //   json = <JSON> obj;
  //   gtag('event', 'tribune_comment_reported', {
  //     'event_category': 'Tribune',
  //     'event_label': JSON.stringify(json)
  //   });
  // }

  // analyticTribuneReplyReported(reason: string) {
  //   let json: JSON;
  //   let obj: any = {
  //     'reason' : reason
  //   };
  //   json = <JSON> obj;
  //   gtag('event', 'tribune_reply_reported', {
  //     'event_category': 'Tribune',
  //     'event_label': JSON.stringify(json)
  //   });
  // }
}

export class ReportBottomsheetModel {
  constructor(
    public type: string,
    public firstTitle: string,
    public secondTitle: string,
    public optionsTitle: string[],
    public postId?: string,
    public id?: string
  ) {}
}
